import { Container } from "rsuite"
import { useCustomTheme } from "../../hooks/useCustomTheme";
import { ContentHeader } from "../../components/ContentHeader";
import logo_uni from '../../assets/logo_uni.png';
import { FaConciergeBell, FaWhatsapp, FaInbox } from "react-icons/fa";
import * as S from "./styles";
import { useCallback } from "react";
import api from "../../services/api";
import { useState } from "react";
import { useEffect } from "react";
import { LoadingSpinner } from "../../components/LoadingSpinner";

const ServicosSolucoes = () => {
  const [systems, setSystems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { theme } = useCustomTheme();

  const loadSystems = useCallback(async () => {
      await api.get('sistemas-solucoes/listar')
      .then((response) => setSystems(response.data))
      .catch(error => console.log(error.response.data))
      .finally(() => setLoading(false))
  },[])

  const handleHire = useCallback((name) => {
    const numero = '5563991000057';
    const mensagem = `Olá! Poderia me fornecer mais detalhes sobre o produto ${name}?`;
    const mensagemFormatada = encodeURIComponent(mensagem);

    let linkGenerated = `https://wa.me/${numero}?text=${mensagemFormatada}`;
    window.open(linkGenerated, '_blank');
  },[]);

  const GridItem = ({title, description, index}) => {
    return (
      <S.Grid index={index}>
        <S.HeaderGrid>
            <S.HeaderIcon src={logo_uni}/>
            <S.HeaderText>{title}</S.HeaderText>
        </S.HeaderGrid>
        <S.BodyGrid>
          <S.BodyContent>
            {description}
          </S.BodyContent>
          <S.ContainerGridButton>
            <S.GridButton onClick={() => handleHire(title)}>
              Saiba mais
              <FaWhatsapp size={15} />
            </S.GridButton>
          </S.ContainerGridButton>
        </S.BodyGrid>
    </S.Grid>
    )
  }

  useEffect(() => {
    loadSystems();
  },[loadSystems])

  return(
    <Container
      style={{
        height: 'calc(100vh - 60px)',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Serviços e Soluções"
        subtitle="Confira as opções disponíveis e converse com a gente para saber mais"
        icon={FaConciergeBell}
      />
      <S.ScrollArea>
        {loading ?
          <S.CenteredState><LoadingSpinner /></S.CenteredState> :
          <S.ContainerGrid>
            {systems.length === 0 ? (
              <S.EmptyState>
                <FaInbox size={40} />
                <span>Nenhum serviço disponível no momento.</span>
              </S.EmptyState>
            ) : (
              <S.GridList>
                {systems.map((sys, index) =>
                  <GridItem
                    key={sys.Id ?? sys.Nome}
                    title={sys.Nome}
                    description={sys.Descricao}
                    index={index}
                  />
                )}
              </S.GridList>
            )}
          </S.ContainerGrid>
        }
      </S.ScrollArea>
    </Container>
  )
}
export default ServicosSolucoes;
